exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CustomImageRenderer .default-type-string-format-image-thumbnail{cursor:pointer;width:100%}", ""]);

